import { render } from "./i18n-flags.vue?vue&type=template&id=6601bbff"
import script from "./i18n-flags.vue?vue&type=script&lang=js"
export * from "./i18n-flags.vue?vue&type=script&lang=js"

import "./i18n-flags.vue?vue&type=style&index=0&id=6601bbff&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__